/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Out_3Inputs */

const en_services_flow_out_3 = /** @type {(inputs: Services_Flow_Out_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next follow-up`)
};

const lv_services_flow_out_3 = /** @type {(inputs: Services_Flow_Out_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nākamā ziņa klientam`)
};

/**
* | output |
* | --- |
* | "Next follow-up" |
*
* @param {Services_Flow_Out_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_out_3 = /** @type {((inputs?: Services_Flow_Out_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Out_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_out_3(inputs)
	return en_services_flow_out_3(inputs)
});